import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const RestaurantCartSettings = lazyWithRetry(() => import(/* webpackChunkName: "restaurant-cart-settings" */'../../component/RestaurantCartSettings'))

const RestaurantCartSettingsPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<RestaurantCartSettings />
		</Suspense>
	)
})

RestaurantCartSettingsPage.displayName = 'RestaurantCartSettingsPage'
export default RestaurantCartSettingsPage
